module.exports = __webpack_public_path__ + "static/media/Scotiabank HCRA Freeze Orders - Lynphyl Homes et al. - June 18 2024.d60db780.pdf";